import React, { FC } from "react";

import { DateInput, PhoneNumberInput, SelectInput, TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";

import { DataSchemaMapped, FieldType } from "../../utils";
import { StyledInputContainer } from "./styled";

type InfoFieldEditProps = {
    field: DataSchemaMapped;
    label: string;
    error?: any;
    control?: any;
};

export const InfoFieldEdit: FC<InfoFieldEditProps> = ({ field, label, control }) => {
    const { id, reference, size, type, required = false, readMode = false, options = [], maxLength } = field;

    const render = () => {
        switch (type) {
            case FieldType.Phone:
                return (
                    <PhoneNumberInput
                        name={id}
                        control={control}
                        disabled={readMode}
                        margin="none"
                        label={label}
                        required={required}
                    />
                );
            case FieldType.Date:
                return <DateInput name={id} control={control} disabled={readMode} label={label} required={required} />;
            case FieldType.PairId:
                return (
                    <RefSelectInput
                        name={id}
                        label={label}
                        control={control}
                        disabled={readMode}
                        required={required}
                        withEmptyOption
                        table={reference}
                    />
                );
            case FieldType.MultiSelect:
                return (
                    <SelectInput
                        name={id}
                        label={label}
                        control={control}
                        disabled={readMode}
                        required={required}
                        options={options}
                        multiple
                    />
                );
            case FieldType.String:
                return (
                    <TextInput
                        name={id}
                        label={label}
                        required={required}
                        disabled={readMode}
                        autoComplete="off"
                        control={control}
                        maxLength={maxLength}
                    />
                );
        }
    };

    return <StyledInputContainer $size={size}>{render()} </StyledInputContainer>;
};

export default InfoFieldEdit;
